import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthenticationService } from 'src/app/services/authentication.service';
import { WorkflowContextService } from 'src/app/services';
import { SecurityService } from 'src/app/services';
import { CommonConfirmationModalData } from
  'src/app/components/common/common-confirmation-modal/common-confirmation-modal.component.model';
import { Location } from '@angular/common';
import { Images } from 'src/assets/export.assets';
import { applicantHomeRoutesNames } from 'src/app/services/mock-data/applicant-home-constants/applicant-home-constants';

@Component({
  selector: 'wm-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  standalone: false
})
export class ChangePasswordComponent implements OnInit {
  logoApplicantSrc='assets/images/placeholder-logo/placeholder-logo.png' //code added by Sanchit on 03/18/2026
  // logoApplicantSrc='favicon.ico'

  form!: FormGroup;
  private isSuccessFlow = false;
  private applicantHomeUrl = '';
  headerLayout : 'staff' | 'applicant' | 'none' = 'none'
  logoSrc = Images.geoPermitsLogo;
  userNameData = {
    text: this.context.user?.name 
  };
  profileImageClass!: string;

  // Simple string variables to safely track errors without triggering NG0100
  currentPasswordError = '';
  newPasswordError = '';
  confirmPasswordError = '';

  get profileImageSrc(): string {
    const path = this.context.user?.userProfileImageURL;
    if (!path) {
      return Images.dummyProfilePic;
    }
  
    return path.startsWith('http')
      ? path
      : `${window.location.origin}${path}`;
  }
  showProfileMenuOfApplication = true;


onGeoPermitLogoClick = ()=>{
this.router.navigate(['/']);
}

  saveAndExitModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: '',
    modalSubDescp: '',
    yesNoBtn: false,
    okBtn: true,
    closeBtn: false,
    inTime: 300,
    outTime: 200,
    status: 'default'
  };

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthenticationService,
    private securitySvc: SecurityService,
    public context: WorkflowContextService,
    private location:Location,    
    private route : ActivatedRoute

  ) {
    
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      const from = params.get('from');
      if (from === 'staff' || from === 'applicant') {
        this.headerLayout = from;
      } else {
        this.headerLayout = 'none';
      }
    })
    this.form = this.fb.group({
      currentPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required]
    });

    // Cleanly update error variables synchronously on any change
    this.form.valueChanges.subscribe(() => {
      this.updateErrors();
    });
    this.form.statusChanges.subscribe(() => {
      this.updateErrors();
    });

    this.setApplicantHomeUrl();
    const hasProfileImage = !!this.context.user?.userProfileImageURL


    this.profileImageClass = hasProfileImage
      ? 'profile-image'
      : 'applicant-profile-pic'
  }

  private updateErrors(): void {
    // Directly updating primitive strings ensures the UI detects the change 
    // immediately without losing cursor focus.
    this.currentPasswordError = this.getError('currentPassword');
    this.newPasswordError = this.getError('newPassword');
    this.confirmPasswordError = this.getError('confirmPassword');
  }

  private setApplicantHomeUrl(): void {
    const url = this.router.url; 
    const index = url.indexOf('/applicant-home');

    this.applicantHomeUrl =
      index !== -1 ? url.substring(0, index + '/applicant-home'.length) : '/';
  }

  private redirectToHome(): void {
  const from = this.route.snapshot.queryParamMap.get('from');

  if (from === 'staff') {
    this.location.back();
    return;
  }

  const clientIdFromContext = this.context?.client?.id;
  const clientIdFromUrl =
    this.router.url.match(/\/jurisdiction\/([^\/]+)/)?.[1] || null;
  const clientId = clientIdFromContext || clientIdFromUrl;

  if (clientId) {
    this.router.navigateByUrl(
      `/jurisdiction/${clientId}/${applicantHomeRoutesNames.root}/${applicantHomeRoutesNames.applyForPermit.route}`
    );
    return;
  }

  this.router.navigateByUrl(
    `/${applicantHomeRoutesNames.root}/${applicantHomeRoutesNames.applyForPermit.route}`
  );
}

  onBack(): void {
    this.location.back()
  }

  onCancel = (): void => {
    // this.router.navigateByUrl(this.applicantHomeUrl);
    this.location.back()

  };

  onSave = (): void => {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.updateErrors(); // Force immediate error variable update when SAVE is clicked
      return;
    }

    const { currentPassword, newPassword, confirmPassword } = this.form.value;
    const username = this.context.user?.userName;

    if (!username) {
      this.openModal('Error', 'User context not available', 'error');
      return;
    }

    if (newPassword !== confirmPassword) {
      this.openModal('Error', 'Passwords do not match', 'error');
      return;
    }

    this.authService
      .changePwd(username, currentPassword, newPassword, confirmPassword)
      .subscribe({
        next: (res: any) => {
          this.isSuccessFlow = res?.succeeded === true;

          this.openModal(
            this.isSuccessFlow ? 'Success' : 'Error',
            this.isSuccessFlow
              ? 'Password changed successfully'
              : (res?.responseMessage || 'Unable to change password'),
            this.isSuccessFlow ? 'success' : 'error'
          );
        },
        error: () => {
          this.openModal(
            'Error',
            'Something went wrong. Please try again.',
            'error'
          );
        }
      });
  };

  handleSaveAndExit(): void {
    this.saveAndExitModalData = {
      ...this.saveAndExitModalData,
      open: false
    };

    if (this.isSuccessFlow) {
      // this.router.navigateByUrl(this.applicantHomeUrl);
       //  Replace navigateByUrl with redirectToHome
    setTimeout(() => {
      this.redirectToHome();
    }, 500); // small delay so modal closes cleanly
    }
  }

  saveAndExitcloseModal(): void {
    this.saveAndExitModalData = {
      ...this.saveAndExitModalData,
      open: false
    };
  }

  getError(controlName: string): string {
    const control = this.form.get(controlName);

    if (!control || !control.touched || !control.invalid) {
      return '';
    }

    return control.hasError('required') ? 'Required' : '';
  }

  private openModal(
    title: string,
    message: string,
    status: 'success' | 'error' | 'default'
  ): void {
    this.saveAndExitModalData = {
      ...this.saveAndExitModalData,
      open: true,
      modalDescp: title,
      modalSubDescp: message,
      status,
      okBtn: true,
      yesNoBtn: false,
      closeBtn: false
    };
  }

  //added by omkar on 18/03/2026
  signOutModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Confirm Sign Out',
    modalSubDescp: 'This will end your session, are you sure you want to sign out?',
    yesNoBtn: true,
    okBtn: false,
    closeBtn: false,
    inTime: 300,
    outTime: 200,
    status: 'default'
  };

  goToEditProfile = () => {
    this.router.navigate(['/auth', 'edit-profile'], {
      queryParams: { from: 'applicant' }
    });
  };

  goToChangePassword = () => {
    this.router.navigate(['/auth', 'change-password'], {
      queryParams: { from: 'applicant' }
    });
  };

  onSignOutClick = () => {
    this.signOutModalData = {
      ...this.signOutModalData,
      open: true
    };
  };

  handleSignOutModalAccepted = () => {
    this.securitySvc.logout().subscribe({
      next: () => this.router.navigate(['/']),
      error: () => this.router.navigate(['/'])
    });
  };

  handleSignOutModalRejected = () => {
    this.signOutModalData = {
      ...this.signOutModalData,
      open: false
    };
  };

  //end by omkar on 18/03/2026

}
